import * as types from './types'
import { FLIRT_LIKE, FLIRT_DISLIKE } from '../flirt/types'
import { objectReducer, unique } from 'utils'

// import generate from 'mocks/data/notifications';
// const items = generate(3);

const initialState = {
  // items,
  items: [],
  looking: false,
}

const removeItem = (state, item) => ({ ...state, looking: false, items: state.items.filter(e => e.id !== item.id) })

const notifications = objectReducer(types.FETCH_NOTIFICATIONS, initialState, {
  success: (payload, { items }) => ({ items: unique(items.concat(payload)) }),

  extra: (state, { type, notification }) => {
    const { items, looking } = state

    switch (type) {
      case types.SEE_NOTIFICATIONS:
        return { ...state, looking: true }

      case types.HIDE_NOTIFICATIONS:
        return { ...state, looking: false, items: items.map(n => ({ ...n, seen: true })) }

      case types.TIMEOUT_NOTIFICATIONS:
        return looking ? state : { ...state, items: items.map(n => ({ ...n, seen: true })) }

      case types.CONSUME_NOTIFICATION_SUCCESS:
        return removeItem(state, notification)

      case types.CONSUME_NOTIFICATION:
        return notification.fake ? removeItem(state, notification) : state

      case types.FLIRT_POPUP:
        return { ...state, items: [notification, ...items.filter(e => e.typeAlias != types.FLIRT_POPUP)] }

      case FLIRT_LIKE:
      case FLIRT_DISLIKE:
        const popup = items.find(e => e.typeAlias == types.FLIRT_POPUP)
        return popup ? removeItem(state, popup) : state

      default:
        return state
    }
  },
})

export default notifications
